import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import RegisterForm from '../Register/RegisterForm';

const AddSelfManagedAccount = observer(class AddSelfManagedAccount extends React.Component {
  render() {
    const { translation } = this.props;

    return (
      <div className="drawer__content">
        <header className="drawer__header">
          <div className="wrap">
            <h1 className="drawer__title">{translation.heading}</h1>
          </div>
        </header>

        <div className="wrap">
          <RegisterForm {...this.props} />
        </div>
      </div>
    )
  }
})

export default translate('AddSelfManagedAccount')(AddSelfManagedAccount);


// WEBPACK FOOTER //
// ./src/app/components/SelfManagedAccounts/AddAccount.js